import script from "./ToolRail.vue?vue&type=script&setup=true&lang=js"
export * from "./ToolRail.vue?vue&type=script&setup=true&lang=js"

import "./ToolRail.vue?vue&type=style&index=0&id=3c5675ec&lang=css"

const __exports__ = script;

export default __exports__